import req from "../methods/req"
import method from '../methods/method'

// 获取列表
export const getContractList = function (data){
    return method.get_list({
        url:'/manage/crm.freezer/getContractList',
        ...data
    })
}

export const getContractInfo = function (data){
	return req({
		url:'/manage/crm.freezer/getContractInfo',
		...data,
	})
}
// 获取搜索状态
export const getStatusSelect = function (data){
	return req({
		url:'/manage/crm.freezer/getStatusSelect',
		...data,
	})
}
// 获取审批列表
export const getBindingApprovalList = function (data){
    return method.get_list({
        url:'/manage/crm.freezer/getBindingApprovalList',
        ...data
    })
}

// 冰柜调拨记录
export const getApprovalTransferRecord = function (data){
    return method.get_list({
        url:'/manage/crm.freezer/getApprovalTransferRecord',
        ...data
    })
}

// 导出冰柜调拨记录
export const exportApprovalTransferRecord = function (data){
    return req({
		url:'/manage/crm.custom_export/export',
		...data,
	})
}





// 推送记录列表
export const getPushDrpRecord = function (data){
    return method.get_list({
		url:'/manage/crm.system/getPushDrpRecord',
		...data,
	})
}


//drp推送类目
export const getPushDrpSelect = function (data){
	return req({
		url:'/manage/crm.system/getPushDrpSelect',
		...data,
	})
}


//drp重新推送
export const pushAgain = function (data){
	return req({
		url:'/manage/crm.system/pushAgain',
		...data,
	})
}


